export function maybe_open_review_popup(e, url) {
	const popup_el = document.getElementById(`js-popup-review`);
	if (!popup_el) {
		return;
	}

	const storage_key = `sh_review_popup_click_count`;

	let count = parseInt(localStorage.getItem(storage_key), 10);
	if (!count) {
		count = 0;
	}

	count++;

	localStorage.setItem(storage_key, count);

	if (count !== 2) {
		return;
	}

	const url_el = document.getElementById(`js-popup-review-url`);
	if (!url_el) {
		return;
	}

	e.preventDefault();

	url_el.href = url;

	window.sh_popups[`js-popup-review`].open();
}
